import React from 'react'

const OilRecordItem = ({date, quantity, ecopoints}) => {
  return (
    <React.Fragment>
        <div>{date}</div>
        <div>{quantity}</div>
        <div>{ecopoints}</div>
    </React.Fragment>
  )
}

export default OilRecordItem